import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AutomationErrorComponent } from 'src/app/middleware/common/automationError/automationError.component';

@Component({
  selector: 'app-manage-AutomationProcessReport',
  templateUrl: './manage-AutomationProcessReport.component.html',
  styleUrls: ['./manage-AutomationProcessReport.component.scss']
})

export class ManageAutomationProcessReportComponent implements OnInit {

  formDialog: FormGroup;
  updateformDialog: FormGroup;

  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
    OfficeIDList:[],
    officeID:0   
  };
  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  currentUser: any;
  organizationId: string;
  responseHolder: any;
  folderList: any[]=[];  
  value = ''; 
  paginatorTotalLength: any;
  //dataSource: any;
  dataCount: any;
  pageChangeEvent: any;
  pageIndex: any;
  pageSize: any;

  OfficeIDList: any=[];
  myOfficeID: any;
  ShowNoRecordFound:boolean=false;
  spinner:boolean=false;
  taskStatusID:number=0;

  cType:number=1;
  CoreShowName: string = "";
  ContactShowName: string = "";
  CompanyShowName: string = "";
  menuModulesList: any = [] = [];
  folderID:number=0;
  FormReportfolderList: any = [] = [];
  ShowNoRecordFoundForms:boolean=false;
  databaseId:any;
  templateName:string="";
  aITemplateList: any = [] = [];
  filterText:string="";
  aiAutomationTemplateID:number=0;
  showAddUpdateButton:boolean=true;
  PromptTemplateName:string="";
  PromptTemplateID:number=0;
  FieldTemplateName:string="";
  FieldTemplateID:number=0;


  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService,
     private toastr: ToastrService, private statusConst: StatusConstant, 
     private reusableClass: ReusableClasses, private dialog: MatDialog,
     private settingsService: SettingService, private encryptionAlgo: EncryptionService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.organizationId = sessionStorage.getItem('organizationID');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnInit(): void {
    this.getAIAutomationProcesses(); 
  } 
  
  getAIAutomationProcesses() {
    this.loaderService.show();   
    var ReqModel = {
      keyword:this.filterText,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID:Number(this.databaseId)
     }
    this.settingsService.getAIAutomationProcesses(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.aITemplateList = this.responseHolder.data.processes;
          if(this.aITemplateList==null){
            this.aITemplateList=[];
          }         
          if(this.aITemplateList.length>0){
            this.ShowNoRecordFound=false;
          }else{
            this.ShowNoRecordFound=true;
           }     
        }
        else {
          this.ShowNoRecordFound=true;
          this.aITemplateList=[];      
          this.loaderService.hide();
        }
      }
      else {
        this.ShowNoRecordFound=true;
        this.aITemplateList=[];     
        this.loaderService.hide();
      }
    });
  } 

 
  deleteAIAutomationTemplate(data: any) { 
    var message = `Are you sure you want to delete?`;  
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });  
     dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();       
        var ReqModel ={
          aiAutomationID:data.aiAutomationID,  
          organizationID: Number(this.organizationId),  
          userID: this.currentUser.UID,  
          officeID:this.myOfficeID,
          databaseID:Number(this.databaseId)
        }        
        this.settingsService.removeAIAutomationProcess(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.toastr.success('Record deleted successfully.', '', {
                timeOut: 3000,
              });
              this.filterText = "";
              this.getAIAutomationProcesses();
              this.loaderService.hide();
            }else{
              this.filterText = "";
              this.getAIAutomationProcesses();
              this.loaderService.hide();
            }
          }
        });
      }
    });
  }  

  Search(filterValue) {
    this.filterText = filterValue;
    //this.pageModelData.searchValue = filterValue;
    this.getAIAutomationProcesses();
   }

  clearFilter(){
    this.value = "";
    this.filterText = "";
    //this.pageModelData.searchValue = this.filterText;
    this.getAIAutomationProcesses();
   }

   ReRunAutomationForAITool(data:any) {
    //this.loaderService.show();   
    var ReqModel = {
      aiAutomationID:data.aiAutomationID,
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      databaseID:Number(this.databaseId)
     }
     this.dialog.closeAll();
     this.toastr.success('The automation process may take a few minutes. You can continue other tasks on Flowtrics and refresh the list later to check the status.', '', {
       timeOut: 3000,
     });
    this.settingsService.reRunAutomationForAITool(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
         // this.getAIAutomationProcesses();        
        }
        else {           
          this.loaderService.hide();
        }
      }
      else {        
        this.loaderService.hide();
      }
    });
  } 

    showAutomationError(data) {
      const dialogRef = this.dialog.open(AutomationErrorComponent, {     
        data: {
          error: data.error,
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if(result!=null && result!=undefined){      
        }      
      });
    } 
 
}

